import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Language from "../language/language";
import { Table, Modal, Button } from "antd";
import { $const } from "../../helper";
import IndividualEventsList from "./individualEventsList";
import EntryListModal from "./entryListModal";

import "./stylesheets/controlCenter.scss";

const { Column } = Table;

@inject("teamStore", "languageStore", "authStore", "personGameStore", "commonStore")
@withRouter
@observer
export default class ControlCenter extends React.Component {
  state = {
    entryListModalVidible: false,
    selectedTeamInfo: null
  };
  goDetail = record => {
    this.props.commonStore.gTag("event", "viewEvents", {
      pageName: "controlCenter",
      buttonName: "查看"
    });
    if (!record.isApplication) {
      if (record.precheck === $const.CLICK_APPLY_GAME.YES) {
        this.props.history.push(`/game-apply-info/${record.id}`);
      } else {
        this.props.history.push(`/team-apply/${record.id}`);
      }
    } else {
      this.props.teamStore.setApplicationTeamInfo(
        {
          id: record.id,
          collegeName: record.collegeName,
          name: record.teamName
        },
        {
          gappliction: {
            id: record.applicationId,
            teamId: record.id
          },
          eventRoleId: record.eventRoleId,
          eventPositionId: record.eventPositionId
        }
      );
      this.props.history.push("apply-team-success");
    }
  };
  componentDidMount() {
    this.props.teamStore.getMyTeams();
    this.props.teamStore.getApplication();
    this.props.personGameStore.getEvents();
  }

  formatTeam = (teams, lang) => {
    let newTeams = [];
    let length = teams.length;
    for (let i = 0; i < length; i++) {
      let team = teams[i];
      let members = teams[i].gteamMembers.nodes;
      let captain = "";
      let position = "";
      // 获取队长
      members.forEach(member => {
        if (
          member.eventPosition &&
          member.eventPosition.position &&
          member.eventPosition.position.code === $const.CAPTAIN
        ) {
          if (member.member) {
            captain = member.member.nickname;
          }
        }
      });
      // 获取自己的职位
      members.forEach(member => {
        if (
          this.props.authStore.user.id &&
          this.props.authStore.user.id.toString() === member.memberId
        ) {
          position =
            member.eventPosition &&
            member.eventPosition.position.nameUuidI18n[this.props.languageStore.lang];
        }
      });
      let school = "";

      if (team.collegeName) {
        // 手动录入
        school = team.collegeName;
      } else if (team.college && team.college.name) {
        // 选中学校
        school = team.college && team.college.name;
      } else {
        // 联队情况
        school = team.collegeName;
      }
      newTeams.push({
        id: team.id,
        precheck: team.precheck,
        gameType: team.gevent.titleUuidI18n[lang],
        teamName: team.name,
        school: school,
        captain: captain,
        position: position,
        gameStatus: team.status,
        status: team.status,
        registrations: team.registrations
      });
    }
    this.props.teamStore.myApplication.length > 0 &&
      this.props.teamStore.myApplication.forEach(application => {
        // 有注册
        if (application.status === $const.TEAM_APPLICATION_STATUS.PENDING && application.team) {
          let captain = "";
          let position = "";
          // 获取队长
          if (application.team && application.team.captain) {
            captain = application.team.captain.nickname;
          }
          // 获取自己的职位
          if (
            application.eventPosition &&
            application.eventPosition.position &&
            application.eventPosition.position.nameUuidI18n
          ) {
            position = application.eventPosition.position.nameUuidI18n[lang];
          }
          let school = "";
          if (application.team.collegeName && application.team.collegeBadge) {
            school = application.team.collegeName;
          } else {
            school = application.team.college && application.team.college.name;
          }
          newTeams.push({
            isApplication: true,
            collegeName: school,
            applicationId: application.id,
            eventRoleId: application.eventRoleId,
            eventPositionId: application.eventPositionId,
            id: application.team.id,
            precheck: application.team.precheck,
            gameType: application.team.gevent.titleUuidI18n[lang],
            teamName: application.team.name,
            school: school,
            captain: captain,
            position: position,
            gameStatus: application.team.status,
            status: application.team.status,
            registrations: application.team.registrations
          });
        }
      });
    return newTeams;
  };

  formatEvents = (events, lang) => {
    let newEvents = [];
    if (events) {
      for (let i = 0; i < events.length; i++) {
        let item = events[i];
        let stageId = item.stageId;
        let registration;
        item.registrationStageStatuses &&
          item.registrationStageStatuses.nodes &&
          item.registrationStageStatuses.nodes.forEach(node => {
            if (node.stageId === stageId) {
              registration = node;
            }
          });
        newEvents.push({
          id: item.id,
          gameName: item.event && item.event.titleUuidI18n && item.event.titleUuidI18n[lang],
          currentStage:
            registration &&
            registration.stage &&
            registration.stage.nameUuidI18n &&
            registration.stage.nameUuidI18n[lang],
          currentStatus:
            registration &&
            registration.stageStatus &&
            registration.stageStatus.status &&
            registration.stageStatus.status.nameUuidI18n &&
            registration.stageStatus.status.nameUuidI18n[lang]
        });
      }
    }
    return newEvents;
  };

  renderText(text, record) {
    return <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>{text}</div>;
  }

  showEntryList = info => {
    this.setState({
      entryListModalVidible: true,
      selectedTeamInfo: info
    });
  };

  render() {
    if (!this.props.authStore.user.id) {
      return <div className="congtrol-center"></div>;
    }
    const teams = this.formatTeam(this.props.teamStore.myTeams, this.props.languageStore.lang);
    const events = this.formatEvents(
      this.props.personGameStore.myEvents,
      this.props.languageStore.lang
    );

    return (
      <div className="congtrol-center">
        {teams.length > 0 ? (
          <div data-perf>
            <Table
              dataSource={teams}
              rowKey="id"
              title={() => <Language resource="GAME_CONTROL" />}
            >
              <Column
                title={<Language resource="GAME_TYPE" />}
                dataIndex="gameType"
                key="gameType"
                render={this.renderText}
                width={200}
              ></Column>
              <Column
                title={<Language resource="TEAM_NAME" />}
                dataIndex="teamName"
                key="teamName"
                render={this.renderText}
                width={150}
              ></Column>
              <Column
                title={<Language resource="TEAM_SCHOOL" />}
                dataIndex="school"
                key="school"
                ellipsis
                render={this.renderText}
                width={300}
              ></Column>
              <Column
                title={<Language resource="ENTRY_LIST" />}
                key="entryList"
                width={100}
                render={(text, record) => {
                  return record.id ? (
                    <div className="action">
                      <div className="spe-link" onClick={() => this.showEntryList(record)}>
                        <Language resource="VIEW"></Language>
                      </div>
                    </div>
                  ) : null;
                }}
              ></Column>
              <Column
                title={<Language resource="DETAIL" />}
                key="action"
                width={60}
                render={(text, record) => (
                  <div className="action">
                    <div className="spe-link" onClick={this.goDetail.bind(this, record)}>
                      <Language resource="VIEW"></Language>
                    </div>
                  </div>
                )}
              ></Column>
            </Table>
          </div>
        ) : null}
        <IndividualEventsList events={events} />
        <Modal
          visible={this.state.entryListModalVidible}
          getContainer={false}
          destroyOnClose
          onCancel={() =>
            this.setState({
              entryListModalVidible: false
            })
          }
          footer={[
            <Button
              key={"confirm"}
              onClick={() =>
                this.setState({
                  entryListModalVidible: false
                })
              }
              type="primary"
            >
              <Language resource="CONFIRM" />
            </Button>
          ]}
          width={1200}
        >
          <EntryListModal info={this.state.selectedTeamInfo} />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/controlCenter/controlCenter.js